export const AUTOMATION_INTEGRATION_CARD_TITLES = {
  TIKTOK_PIXEL: "TikTok Pixel",
  FACEBOOK_META_PIXEL: "Facebook (Meta) pixel",
  GOOGLE_CALENDAR: "Google calendar",
  GOOGLE_MEET: "Google meet",
  ZOOM: "Zoom",
  TELEGRAM: "Telegram",
  GOOGLE_DRIVE: "Google drive",
  ZAPIER: "Zapier",
} as const;

export type AutomationIntegrationCardTitle =
  (typeof AUTOMATION_INTEGRATION_CARD_TITLES)[keyof typeof AUTOMATION_INTEGRATION_CARD_TITLES];
